import { StructuredData } from './StructuredData';
import { AssetUrls } from 'config/assets';

interface OrganizationSchemaProps {
  includeWebSite?: boolean;
}

/**
 * OrganizationSchema - Site-wide Organization + WebSite structured data
 *
 * Use on homepage and major landing pages.
 * Includes sitelinks search box for Google search integration.
 *
 * Usage:
 * <OrganizationSchema includeWebSite={true} />
 */
export const OrganizationSchema: React.FC<OrganizationSchemaProps> = ({
  includeWebSite = false,
}) => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'TradeMagic',
    alternateName: 'Trade Magic',
    url: 'https://trademagic.gg',
    logo: AssetUrls.logos.black,
    description:
      'The easiest way to trade Magic: The Gathering cards. Join the best community of MTG players trading cards by mail.',
    // Launch month and founder per the About page (Asana 1219261192406735).
    foundingDate: '2025-11',
    founder: {
      '@type': 'Person',
      name: 'Eric Freytag',
      sameAs: 'https://www.linkedin.com/in/ericfreytag/',
    },
    sameAs: [
      'https://x.com/trademagic_gg',
      'https://bsky.app/profile/trademagic.bsky.social',
      'https://reddit.com/r/trademagic',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'support@trademagic.gg',
      contactType: 'Customer Support',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TradeMagic',
    url: 'https://trademagic.gg',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://trademagic.gg/search/results?name={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <StructuredData data={organizationSchema} />
      {includeWebSite && <StructuredData data={webSiteSchema} />}
    </>
  );
};
